import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Select,
    Table,
    Tag,
    Radio,
    Tabs, Spin
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";

const {Title, Text} = Typography;
const {Content} = Layout;
const {RangePicker} = DatePicker;
const { TabPane } = Tabs;

const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '提货编号',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: '提货单位',
        dataIndex: 'buyer',
        key: 'buyer',
    },
    {
        title: '提货类型',
        dataIndex: 'stock',
        key: 'stock',
    },
    {
        title: '提货量（吨）',
        dataIndex: 'value',
        key: 'value',
        sorter: (a, b) => a.value - b.value,
        render: (value) => <p>{value ? (value/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '提货车辆',
        dataIndex: 'car',
        key: 'car',
    },
    {
        title: '提货时间',
        dataIndex: 'time',
        key: 'time',
        render: (time) => <p>{time ? time.substring(0,19) : '无'}</p>,
    },
];

const Load = (that,start,end) => {
    that.setState({
        isLoaded: true,
    });
/*
    fetch("http://pd.pokemonbye.com:8087/api/getsellbillbydate?start=" + start + "&end=" + end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                console.log(array)
                that.setState({
                    isLoaded: true,
                    list: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )*/

    fetch("https://pd.pokemonbye.com:8081/api/getweightbetdate?start=" + start + "&end=" + end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                var listsum = 0;
                var listnum = 0;
                for (let i = 0; i < array.length; i++) {
                    array[i].key = i + 1;
                    listsum += parseFloat(array[i].value)
                }
                that.setState({
                    isLoaded: false,
                    list: array,
                    listsum: listsum.toFixed(2)
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: false,
                    error
                });
            }
        )
}

const Load2 = (that,start,end,name) => {
    that.setState({
        isLoaded: true,
    });

    fetch("https://pd.pokemonbye.com:8081/api/getweightmaxbyname?start=" + start + "&end=" + end + "&name=" + name)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                var listsum = 0;
                var listnum = 0;
                for (let i = 0; i < array.length; i++) {
                    array[i].key = i + 1;
                    listsum += parseFloat(array[i].value)
                }
                that.setState({
                    isLoaded: false,
                    list: array,
                    listsum: listsum.toFixed(2)
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: false,
                    error
                });
            }
        )
}

const Load3 = (that,start,end,name) => {
    that.setState({
        isLoaded: true,
    });

    fetch("https://pd.pokemonbye.com:8081/api/getweightmaxbystock?start=" + start + "&end=" + end + "&name=" + name)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                var listsum = 0;
                var listnum = 0;
                for (let i = 0; i < array.length; i++) {
                    array[i].key = i + 1;
                    listsum += parseFloat(array[i].value)
                }
                that.setState({
                    isLoaded: false,
                    list: array,
                    listsum: listsum.toFixed(2)
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: false,
                    error
                });
            }
        )
}

const Load4 = (that,start,end,name,stock) => {
    that.setState({
        isLoaded: true,
    });

    fetch("https://pd.pokemonbye.com:8081/api/getweightmaxbynamestock?start=" + start + "&end=" + end + "&name=" + name + "&stock=" + stock)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                var listsum = 0;
                var listnum = 0;
                for (let i = 0; i < array.length; i++) {
                    array[i].key = i + 1;
                    listsum += parseFloat(array[i].value)
                }
                that.setState({
                    isLoaded: false,
                    list: array,
                    listsum: listsum.toFixed(2)
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: false,
                    error
                });
            }
        )
}

class PageDataOrder extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const pid = params.get("area");
        this.state = {
            title: "订单查询",
            county: [],
            area: pid,
            list: [],
            listman: [],
            listcus: [],
            start: moment().subtract(1, "days").format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD') + ' 23:59:59',
            name: '',
            stock: '',
            listsum: 0
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellclient")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].value = array[i].name;
                            array[i].label = array[i].name;
                        }
                        this.setState({
                            isLoaded: false,
                            options: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].value = array[i].stockname;
                            array[i].label = array[i].stockname;
                        }
                        this.setState({
                            isLoaded: false,
                            optionsb: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error
                    });
                }
            )
        Load(this,this.state.start, this.state.end)
    }

    render() {
        const handleChangeb = (value) => {
            this.setState({
                stock: value
            });
            if(this.state.name){
                Load4(this,this.state.start,this.state.end,this.state.name,value)
            }else{
                Load3(this,this.state.start,this.state.end,value)
            }

        };
        const handleChange = (value) => {
            this.setState({
                name: value
            });
            if(this.state.stock){
                Load4(this,this.state.start,this.state.end,value,this.state.stock)
            }else{
                Load2(this,this.state.start,this.state.end,value)
            }

        };
        const onChange = (date, dateString) => {
            console.log(date, dateString);
            let date1 = dateString[0]
            let date2 = dateString[1] + ' 23:59:59'
            this.setState({
                start: date1,
                end: date2
            });
            if(this.state.name&&this.state.stock){
                Load4(this,date1,date2,this.state.name,this.state.stock)
            }else if (this.state.name){
                Load2(this,date1,date2,this.state.name)
            }else if (this.state.stock){
                Load3(this,date1,date2,this.state.stock)
            }else{
                Load(this,date1,date2)
            }
        };
        const onClick = () => {
            fetch("https://pd.pokemonbye.com:8081/api/getweightdataorderexcel?start="+this.state.start+"&end="+this.state.end)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        if(array!=null&&array.length>0){
                            window.open(array[0]);
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {

                    }
                )
        };
        return (
            <div>
                <Leftmenu/>
                <div className="mainpanel">
                    <Header/>
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                                subTitle="筛选查询订单"
                            >
                                <Spin spinning={this.state.isLoaded}>
                                <Space>
                                <RangePicker defaultValue={[moment().subtract(1, "days"), moment()]} onChange={onChange}/>
                                    <Select
                                        defaultValue="筛选提货单位"
                                        style={{
                                            width: 220
                                        }}
                                        onChange={handleChange}
                                        options={this.state.options}
                                    />
                                    <Select
                                        defaultValue="筛选类型"
                                        style={{
                                            width: 100
                                        }}
                                        onChange={handleChangeb}
                                        options={this.state.optionsb}
                                    />
                                    <Button type="primary" onClick={onClick}>下载</Button>
                            </Space>
                                <br/>
                                <br/>
                                <Table bordered={true} columns={columns} dataSource={this.state.list}
                                       pagination={{
                                           pageSize: 100,
                                       }}
                                       summary={() => (
                                           <Table.Summary fixed>
                                               <Table.Summary.Row>
                                                   <Table.Summary.Cell index={0} colSpan={4}>合计</Table.Summary.Cell>
                                                   <Table.Summary.Cell index={1}>{this.state.listsum}</Table.Summary.Cell>
                                                   <Table.Summary.Cell index={2} colSpan={2}></Table.Summary.Cell>
                                               </Table.Summary.Row>
                                           </Table.Summary>
                                       )}/>
                                </Spin>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageDataOrder;


